import React from 'react';
import { generateFullName } from 'utils/badgeHelpers';
import { getCareAgentLabelByType } from 'utils';
import PropTypes from 'prop-types';

const CareAgentItem = ({ field, agents, displayProfType }) => {
  const agent = agents.find((el) => el.type === field.id);

  return (
    <tr>
      <td>{getCareAgentLabelByType(field.id)}</td>
      <td
        data-cy={`care-agents__${field.id}-name`}
        className="care-agents__full-name"
      >
        {agent
          ? generateFullName(
              agent.careAgentTitle,
              agent.careAgentFirstName,
              null,
              agent.careAgentLastName,
            )
          : ''}
        {agent?.status === 'inactive' && (
          <span className="error-message">
            *care agent is currently inactive
          </span>
        )}
      </td>
      {displayProfType && (
        <td>
          <span>{agent?.careAgentProfession}</span>
        </td>
      )}
    </tr>
  );
};

CareAgentItem.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    type: PropTypes.string,
  }),
  agents: PropTypes.arrayOf(
    PropTypes.shape({
      guid: PropTypes.string,
      type: PropTypes.string,
      careAgentGuid: PropTypes.string,
      careAgentFirstName: PropTypes.string,
      status: PropTypes.string,
    }),
  ),
  displayProfType: PropTypes.bool,
};

export default CareAgentItem;
